import { useEffect, useState } from 'react';
import { RemoteParticipant, RemoteTrack, LocalAudioTrack } from 'twilio-video';
import useDominantSpeaker from '../useDominantSpeaker/useDominantSpeaker';
import useVideoContext from '../useVideoContext/useVideoContext';

export default function useParticipants() {
  const { room, localTracks } = useVideoContext();
  const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;
  const dominantSpeaker = useDominantSpeaker();
  const [participants, setParticipants] = useState(Array.from(room?.participants.values() ?? []));

  // When the dominant speaker changes, they are moved to the front of the participants array.
  // This means that the most recent dominant speakers will always be near the top of the
  // ParticipantStrip component.
  useEffect(() => {
    if (dominantSpeaker) {
      setParticipants(prevParticipants => [
        dominantSpeaker,
        ...prevParticipants.filter(participant => participant !== dominantSpeaker),
      ]);
    }
  }, [dominantSpeaker]);

  useEffect(() => {
    if (room) {
      
	 //When click on MuteAll button disable audio track for all the participants
      const trackSubscribed = (track: RemoteTrack): void => {
        if (track.kind === 'data') {
          track.on('message', (data: string) => {
            const dataTrackObj: {actionRequestByAdmin: string} = JSON.parse(data);
            if(dataTrackObj?.actionRequestByAdmin === 'muteAll' && audioTrack.isEnabled) {
              audioTrack.disable()
            }
          });
        }
      };
      
      const participantTrackRegister = (participant: RemoteParticipant) => {
        participant.tracks.forEach(publication => {
          if (publication.track) {
            trackSubscribed(publication.track);
          }
        });
        
        participant.on('trackSubscribed', trackSubscribed);
      };

      const participantConnected = (participant: RemoteParticipant) => {
        setParticipants(prevParticipants => [...prevParticipants, participant]);
        participantTrackRegister(participant)
      };
      const participantDisconnected = (participant: RemoteParticipant) =>
        setParticipants(prevParticipants => prevParticipants.filter(p => p !== participant));

      room.participants.forEach(participantTrackRegister);
      room.on('participantConnected', participantConnected);
      room.on('participantDisconnected', participantDisconnected);
      return () => {
        room.off('participantConnected', participantConnected);
        room.off('participantDisconnected', participantDisconnected);
      };
    }
  }, [room]);

  return participants;
}
